import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import PendoTracker from './components/PendoTracker';
import Navbar from './components/Navbar';
import LandingPage from './components/LandingPage';
import HomePage from './components/HomePage';
import InsightsPage from './components/InsightsPage';
import GeniesPage from './components/Genies';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminTOSProtectedRoute from './components/AdminTOSProtectedRoute';
import GenericChatPage from './components/GenericChatPage';
import AgentChatPage from './components/AgentChatPage';
import LearnMorePage from './components/LearnMorePage';
import VersionPage from './components/VersionPage';
import TestSpnPage from './components/TestSpnPage';
import AdminDashboard from './components/AdminDashboard';
import AdminTOSDashboard from './components/AdminTOSDashboard';
import PowerBIDashboard from './components/PowerBIDashboard';
import DatabricksDashboard from './components/DatabricksDashboard';
import TransitOSLogin from './components/TransitOSLogin';
import fasterQuestions from './questions.json';
import ecolaneQuestions from './ecolane-questions.json';
import AuthenticatedApp from './components/AuthenticatedApp';

const AppLayout = () => {
  const location = useLocation();

  const isHomePage = location.pathname === '/home';
  const isInsightsPage = location.pathname === '/insights';
  const isLandingPage = location.pathname === '/';
  const isLearnMorePage = location.pathname.startsWith('/learn-more/');
  const isAdminPage = location.pathname === '/admin/dashboard' || location.pathname.startsWith('/admin/');
  const isTransitOSPage = location.pathname === '/transitos';

  // Hide navbar on the TransitOS login page (it has its own brand bar)
  const showNavbar = !isTransitOSPage;

  const appStyle = {
    backgroundColor: (isHomePage || isInsightsPage || isLearnMorePage || isTransitOSPage) ? 'transparent' : '#1C1C1C',
  };

  React.useEffect(() => {
    if (isHomePage || isInsightsPage) {
      document.body.classList.add('hide-scrollbar');
    } else {
      document.body.classList.remove('hide-scrollbar');
    }
    return () => {
      document.body.classList.remove('hide-scrollbar');
    };
  }, [isHomePage, isInsightsPage]);

  return (
    <div className="App" style={appStyle}>
      {showNavbar && <Navbar isLanding={isLandingPage} />}
      <main className={`main-content ${isLandingPage ? 'landing-scroll' : ''} ${isAdminPage ? 'admin-scroll' : ''} ${isTransitOSPage ? 'transitos-scroll' : ''}`}>
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/transitos" element={<TransitOSLogin />} />
            <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
            
            {/* Dedicated Chat Routes */}
          <Route path="/faster-chat" element={<ProtectedRoute><GenericChatPage title="FASTER Data Analytics Studio" questions={fasterQuestions} endpoint="/api/faster-chat" /></ProtectedRoute>} />
          <Route path="/ecolane-chat" element={<ProtectedRoute><GenericChatPage title="Ecolane Analytics Studio" questions={ecolaneQuestions} endpoint="/api/ecolane-chat" /></ProtectedRoute>} />
          
          {/* Dynamic Genie Routes */}
          <Route path="/genies" element={<ProtectedRoute><GeniesPage /></ProtectedRoute>} />
          <Route path="/test-spn/:spnName" element={<ProtectedRoute><TestSpnPage /></ProtectedRoute>} />
          <Route path="/chat/:genieId" element={<ProtectedRoute><GenericChatPage /></ProtectedRoute>} />

          {/* Supervisor Agent Routes */}
          <Route path="/agent/:agentId" element={<ProtectedRoute><AgentChatPage /></ProtectedRoute>} />

          {/* Power BI Dashboard */}
          <Route path="/powerbi-dashboard" element={<ProtectedRoute><PowerBIDashboard /></ProtectedRoute>} />

          {/* Databricks AI/BI Dashboard */}
          <Route path="/databricks-dashboard" element={<ProtectedRoute><DatabricksDashboard /></ProtectedRoute>} />

          <Route path="/insights" element={<ProtectedRoute><InsightsPage /></ProtectedRoute>} />

          {/* Other Routes */}
          <Route path="/learn-more/:service" element={<ProtectedRoute><LearnMorePage /></ProtectedRoute>} />
          <Route path="/version" element={<VersionPage />} />

          {/* Admin Routes */}
          <Route path="/admin/dashboard" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />
          <Route path="/admin/tos" element={<AdminTOSProtectedRoute><AdminTOSDashboard /></AdminTOSProtectedRoute>} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <PendoTracker />
      <AuthenticatedApp>
        <AppLayout />
      </AuthenticatedApp>
    </Router>
  );
}

export default App;
